/**
 * Handling time: every seller ships within this many business days of the
 * payment (the client's decision, 2026-10-08). The server stamps each order's
 * ship-by date from its own copy (server/api-util/deadline-rules.js
 * RULES.handlingBusinessDays); handlingTime.parity.test.js keeps the two equal.
 */
export const HANDLING_BUSINESS_DAYS = 3;
